import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import LeftArrowIcon from "images/left-arrow.svg";

const SurveyItemHeader = ({ title, subtitle, closeFeedbackScreen }) => {
  const { isMobileViewport: isMobile } = useSelector(state => state.browser ?? {});

  return (
    <div>
      <div className="flex justify-between items-center mt-4">
        <div className="pl-4 pb-4">
          {!isMobile && (
            <button className="cursor-pointer absolute" onClick={closeFeedbackScreen} aria-label="Back">
              <LeftArrowIcon className="w-2" />
            </button>
          )}
        </div>

        <span className="mx-auto text-h4 font-medium text-center">{title}</span>

        {isMobile && (
          <button className="underline font-medium absolute right-4" onClick={closeFeedbackScreen}>
            Cancel
          </button>
        )}
      </div>

      {subtitle && <p className="text-darkGray text-center my-3 mx-8">{subtitle}</p>}
      <hr className="border-t border-lighterGray" />
    </div>
  );
};

SurveyItemHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  closeFeedbackScreen: PropTypes.func.isRequired,
};

export default SurveyItemHeader;
